import { render, staticRenderFns } from "./AboutUs_phone.vue?vue&type=template&id=05947a8a&scoped=true&"
import script from "./AboutUs_phone.vue?vue&type=script&lang=js&"
export * from "./AboutUs_phone.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_phone.vue?vue&type=style&index=0&id=05947a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05947a8a",
  null
  
)

export default component.exports